import { loginUser } from "../../viewmodels/auth/authViewModel";

export const handleLogin = async (
  email:string,
  password:string
) => {

  try{

    const res = await loginUser(email,password);

    if(res.flag){
      return {success:true};
    }

    return {
      success:false,
      message:res.message || "Login failed"
    };

  }catch{

    return {
      success:false,
      message:"Check email and password again"
    };

  }

};